export default {
      id: "icon-empty-feedback-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-empty-feedback",
      toString: function () {
        return this.url;
      }
    }